<template>
    <mt-input v-bind="$attrs" v-on="$listeners" class="icon-textbox">
        <template #input-append>
            <i class="material-icons">{{ iconType }}</i>
        </template>
    </mt-input>
</template>
<script>
export default {
    name: 'IconTextbox',
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        iconType: {
            type: String,
            default: 'search',
        },
    },
}
</script>
<style>
.icon-textbox {
    i.material-icons {
        position: absolute;
        top: 0;
        left: 8px;
        line-height: 40px;
    }

    input {
        padding-left: 40px;
    }
}
</style>
